import {Routes} from '@angular/router';
import {PageNotFoundComponent} from './views/page-not-found/page-not-found.component';

export const appRoutes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: '/library/'},
  {path: '**', component: PageNotFoundComponent}
];
